import React from 'react'
import PropTypes from 'prop-types'
import { formValues, Field } from 'redux-form/immutable'

import { FormFieldset } from 'layouts/Form'

import Input from 'components/Input'

import {
  scheduleToModifier,
  scheduleToModifierInverted,
  stripTimezones,
} from 'utilities/schedules'
import Calendar from 'components/Calendar'
import { CalendarField } from 'forms/fields'

const makeCalendarProps = (_schedule, _scheduleBooked) => {
  const hasSchedule = typeof _schedule !== 'undefined'
  const today = new Date()
  const scheduleBooked =
    _scheduleBooked != null ? stripTimezones(_scheduleBooked) : []

  const schedule = hasSchedule ? stripTimezones(_schedule) : []
  const bookedUp = schedule.length < 1
  const scheduleModifier =
    hasSchedule && !bookedUp ? scheduleToModifierInverted(schedule) : () => true
  const scheduleModifierBooked = !bookedUp
    ? scheduleToModifier(scheduleBooked)
    : () => false
  const fromMonth = schedule.length > 0 ? schedule[0].start_dt : today
  const toMonth =
    schedule.length > 0 ? schedule[schedule.length - 1].start_dt : today

  return {
    cover: !hasSchedule ? 'Välj ledare' : bookedUp ? <span>Intresserad av denna ledare? Maila <a href="mailto:info@friendtivity.se">info@friendtivity.se</a></span> : undefined,
    disabledDays: scheduleModifier,
    bookedDates: scheduleModifierBooked,
    initialMonth: fromMonth,
    fromMonth,
    toMonth,
    schedule,
  }
}

const schedulePropType = PropTypes.arrayOf(
  PropTypes.shape({
    start_dt: PropTypes.string.isRequired,
    end_dt: PropTypes.string.isRequired,
  }).isRequired,
)

export const ActivityScheduleFormReadOnly = formValues({
  instances: 'instances',
  showModal: 'showModal',
})(({ button, schedule, scheduleBooked, onSubmit }) => {
  const calendarProps = makeCalendarProps(schedule, scheduleBooked)
  const enabled = calendarProps.cover == null
  return (
    <FormFieldset>
      <Field
        {...calendarProps}
        numberOfMonths={2}
        component={Input}
        type={Calendar}
        label="Ledarens tillgängliga dagar"
        name="calendar"
        onDayClick={day => {
          if (enabled) {
            onSubmit({ month: day })
          }
        }}
        monthLarge={false}
      />
      {React.cloneElement(button, {
        disabled: !enabled,
      })}
    </FormFieldset>
  )
})

ActivityScheduleFormReadOnly.propTypes = {
  button: PropTypes.element,
  schedule: schedulePropType,
  scheduleBooked: schedulePropType,
  onSubmit: PropTypes.func.isRequired,
}

ActivityScheduleFormReadOnly.defaultProps = {
  button: null,
  schedule: undefined,
  scheduleBooked: undefined,
}

export const ActivityScheduleForm = ({ schedule, scheduleBooked }) => (
  <FormFieldset>
    <Field
      {...makeCalendarProps(schedule, scheduleBooked)}
      numberOfMonths={1}
      component={Input}
      type={CalendarField}
      label="1. Välj bland tillgängliga blåa veckodagar i kalendern"
      name="calendar"
      monthLarge
      // Override onBlur otherwise redux-form will screw up nested time picker fields
      onBlur={e => {
        e.preventDefault()
      }}
    />
  </FormFieldset>
)

ActivityScheduleForm.propTypes = {
  schedule: schedulePropType,
  scheduleBooked: schedulePropType,
}

ActivityScheduleForm.defaultProps = {
  schedule: undefined,
  scheduleBooked: undefined,
}

export default {
  ActivityScheduleForm,
}



// WEBPACK FOOTER //
// ../source/forms/Activity.js